import { EllipsisModule } from '@delon/abc/ellipsis'
import { FooterToolbarModule } from '@delon/abc/footer-toolbar'
import { FullContentModule } from '@delon/abc/full-content'
import { PageHeaderModule } from '@delon/abc/page-header'
import { QuickMenuModule } from '@delon/abc/quick-menu'
import { ResultModule } from '@delon/abc/result'
import { SEModule } from '@delon/abc/se'
import { STModule } from '@delon/abc/st'
import { SVModule } from '@delon/abc/sv'
import { DelonCacheModule } from '@delon/cache'
import { ChartEChartsModule } from '@delon/chart/chart-echarts'
import { G2WaterWaveModule } from '@delon/chart/water-wave'

export const SHARED_DELON_MODULES = [
  PageHeaderModule,
  STModule,
  SEModule,
  SVModule,
  ResultModule,
  ChartEChartsModule,
  G2WaterWaveModule,
  EllipsisModule,
  FullContentModule,
  FooterToolbarModule,
  DelonCacheModule,
  QuickMenuModule,
]
